<template>
  <b-row align-h="center" class="my-4">
    <h2 class="product__history">History</h2>
    <b-table striped hover :items="history"></b-table>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    id: Number
  },
  computed: {
    ...mapState(['contracts'])
  },
  data() {
    return {
      history: []
    }
  },
  async mounted() {
    const { contracts } = this

    const accounts = sessionStorage.getItem('address')

    try {
      let track = await contracts.Proxy.methods
        .getProductTrack(this.id)
        .call({ from: accounts })

      if (!track) return

      track.forEach(async t => {
        let reg = await contracts.Proxy.methods
          .registrations(Number(t))
          .call({ from: accounts })

        const { ownerAddress, productOwner, trxTimeStamp } = reg

        let owner = await contracts.Proxy.methods
          .participants(ownerAddress)
          .call({ from: accounts })

        if (!owner) return

        const { name, location, participantType } = owner

        const dat = new Date(trxTimeStamp * 1000)

        let formatted_date =
          dat.getMonth() +
          1 +
          '-' +
          dat.getDate() +
          '-' +
          dat.getFullYear() +
          ' ' +
          dat.getHours() +
          ':' +
          dat.getMinutes() +
          ':' +
          dat.getSeconds()

        this.history.push({
          RegistrationID: Number(t),
          productOwner,
          name,
          Role: participantType,
          location,
          Date: formatted_date
        })
      })
    } catch (error) {
      console.log('Error : ', error)
    }
  }
}
</script>

<style>
* {
}
</style>
